<template>
  <Fragment>
    <div class="row mt-4 mt-md-5">
      <div class="col text-center">
        <h1 class="font-main font-weight-bold roi-heading">
          TIREMAAX<sup>®</sup> PRO - ROI CALCULATOR
        </h1>
        <img class="img-fluid" :src="imagePath" alt="Hendrickson Intl." />
      </div>
    </div>
    <div class="row mt-2 mt-md-4 mt-lg-5">
      <div class="col-12 col-md-10 mx-auto text-white">
        <h2 class="h4 font-main font-weight-bold">INSTRUCTIONS:</h2>
        <p>
          Industry data is preloaded; white fields may be edited to align with
          your fleet’s operation. While entering information, do not use the
          browser’s “back” button; instead use the “previous” and “next”
          buttons. Once all data fields are filled, click “Calculate Savings
          Summary” to see ROI summary.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group row mt-5">
          <div class="col-12 text-center">
            <a
              href="#"
              type="button"
              class="btn btn-primary btn-hend btn-large m-1"
              title="Start"
              @click="onStartClick"
            >
              Start
            </a>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

import { store, mutation, mapState } from '../store';

export default {
  name: 'Landing',

  components: { Fragment },

  store,

  data() {
    return {
      imagePath:
        '/getmedia/cecf9f21-7a00-425b-809b-dcbd09231fc1/splash-image.png',
    };
  },

  computed: {
    ...mapState(['stepsSet']),
  },

  methods: {
    onStartClick() {
      this.$store.commit(
        mutation('SET_CURRENT_STEP'),
        this.stepsSet.fleetDetails,
      );
    },
  },
};

/**
 * @typedef {import('../store/state').Step} Step
 */
</script>
